import { ThemeTypes } from '../../../types/Theme.namespace';

export type MenuItemsType = Array<MenuItem | Array<MenuItem>>;

export const VARIANT = {
  DASHBOARD: 'DASHBOARD',
  DEALERHUB: 'DEALERHUB',
} as const;

export type Variant = (typeof VARIANT)[keyof typeof VARIANT];

export type MenuItem = {
  id?: string;
  displayName: string;
  link?: string;
  newTab?: boolean;
  onClick?: () => void;
  icon?: React.ReactNode;
  divider?: boolean;
  notifications?: number | null;
  selected?: boolean;
  variant?: Variant;
  newTabIcon?: boolean;
  betaIcon?: boolean;
  dataTracking?: string;
  itemHidden?: boolean;
  color?: ThemeTypes.Colors;
  displayNextLinkAsShallow?: boolean;
};

export type MenuItemContentProps = {
  item: MenuItem;
  icons: boolean;
};

export type MenuItemProps = {
  variant?: Variant;
} & MenuItemContentProps;

export interface IMenuProps {
  items: MenuItemsType;
  icons?: boolean;
  value?: string;
  variant?: Variant;
  className?: string;
  selectedSection?: string;
  'data-testid'?: string;
}
